import React from 'react';
import { Box } from 'native-base';
import { observer, GIFTCARD_FLOWS, i18nFn } from '@springbig/shared';
import { ActionButton } from '../ActionButton';
import { Caption } from '~/shared/Typography';

const Addpayment = ({ t }: { t: i18nFn }) => {

    return (
        <Box>
            <Caption textAlign={'center'} fontSize={24}>
                { t('general.add') } { t('general.payment') }
            </Caption>
            <ActionButton
                title={t('giftCard.add_cc')}
                onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.addPaymentCard)}
            />
            {/* <ActionButton
                title={'connect bank account'}
                onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.addPaymentBank)}
            /> */}
        </Box>
    );
};

export default Addpayment;
